import { AppButton } from "@libs/zapi-ui/custom";
import { SlidersHorizontal } from "@phosphor-icons/react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useTranslation } from "react-i18next";

type TProps = {
  active: boolean;
  activeFilterCount: number;
  onToggle: () => void;
};

export function FilterToggleButton({ active, activeFilterCount, onToggle }: TProps) {
  const { t } = useTranslation("projects");
  return (
    <AppButton
      type="button"
      appearance="outlined"
      color="zinc150"
      data-testid="filter-toggle"
      aria-pressed={active}
      onClick={onToggle}
      className={cn(
        "h-8 shrink-0 gap-1 !px-3 text-[14px] font-medium !text-innoveraZinc-900 shadow-none [&_svg]:text-innoveraZinc-900",
        active && "bg-zinc-100"
      )}
    >
      <SlidersHorizontal className="h-4 w-4 shrink-0 text-zinc-600" />
      {t("filters.heading")}
      {activeFilterCount > 0 && (
        <span className="ml-0.5 flex items-center justify-center rounded-[4px] bg-[#18181b] px-[5px] py-[3px] text-[12px] font-medium leading-[11px] text-white">
          {activeFilterCount}
        </span>
      )}
    </AppButton>
  );
}
